import ConcernPage from '../Components/Pages/Concern'
import CountrySelectPage from '../Components/Pages/CountrySelect'
import HomePage from '../Components/Pages/Home'
import TicketPage from '../Components/Pages/Ticket'
import AssetDetails from '../Components/Pages/Ticket/AssetDetails'
import TaskDetails from '../Components/Pages/Ticket/TaskDetails'

const base = process.env.PUBLIC_URL || ''

// Pfad zur Country-Auswahl, an mehreren Stellen importiert
// (Login-Redirect, Logo-Klicks etc.).
export const COUNTRY_SELECT_PATH = `${base}/start`

// Basis-Pfade ohne Country-Prefix. Werden unten dupliziert, damit
// /pages/... und /:country/pages/... beide dieselbe Komponente rendern.
const basePaths = [
  { path: `/pages/home`, Component: <HomePage /> },
  {
    path: `/pages/concern/:category/:assetName/:parentId/:projectId/:assetId/`,
    Component: <ConcernPage />,
  },
  { path: `/pages/tickets`, Component: <TicketPage /> },
  { path: `/pages/asset-details/:id`, Component: <AssetDetails /> },
  { path: `/pages/task-details`, Component: <TaskDetails /> },
]

export const routes = [
  { path: COUNTRY_SELECT_PATH, Component: <CountrySelectPage /> },
  ...basePaths.flatMap(({ path, Component }) => [
    { path: `${base}${path}`, Component },
    { path: `${base}/:country${path}`, Component },
  ]),
]
